







































	import {Emit} from "vue-property-decorator";
	import {InOut} from 'vue-inout-prop-decorator';
	import {Component, Vue} from '@/shared/component';

	import {AvisLoyer} from '@/models';

	import CrudAvisLoyerEditLoyer from '@/components/Crud/AvisLoyer/EditLoyer.vue';
	import storeAvisLoyer from "@/stores/modules/avisLoyer";

	@Component({
		components: {
			CrudAvisLoyerEditLoyer,
		}
	})
	export default class CrudAvisLoyerEditLoyerDialog extends Vue {
		@InOut({ type: AvisLoyer  , isVModel: true }) private value!: AvisLoyer;

		@Emit()
		private onSubmit(avisLoyer: AvisLoyer) {
			this.onClose();
		}

		@Emit()
		private async onClose(): Promise<void> {
			this.value = null;
		}

}
